import axios from '../../plugins/axios'

export const actions = {
    listarErros(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(`erros-balanco` + payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    reprocessarErros(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post('erros-balanco', payload)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/erros.js